import { ChangeDetectionStrategy, Component } from '@angular/core';
import { QrCodeGeneratorComponent } from '@shared/components';
import { QRCodeStylingOptions } from '@core/interfaces';

@Component({
  selector: 'app-cp-qr-code-generator',
  imports: [QrCodeGeneratorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2>QR Code Generator!</h2>
    <span> QR Code 1</span>
    <app-qr-code-generator [qrCodeConfig]="qrCodeConfig1" />
    <span> QR Code 2</span>
    <app-qr-code-generator [qrCodeConfig]="qrCodeConfig2" />
  `,
  styles: ``,
})
export class CpQrCodeGeneratorComponent {
  qrCodeConfig1: QRCodeStylingOptions = {
    width: 300,
    height: 300,
    data: 'https://nexttoptech.atlassian.net/browse/YPRJ-1251',
    dotsOptions: {
      color: '#4CAF50',
      type: 'rounded',
    },
    backgroundOptions: {
      color: '#ffffff',
    },
  };

  qrCodeConfig2: QRCodeStylingOptions = {
    width: 300,
    height: 300,
    data: 'https://www.google.com',
    dotsOptions: {
      color: '#000000',
      type: 'square',
    },
    backgroundOptions: {
      color: '#ffffff',
    },
  };
}
